import { APP_URLS } from "settings";

export const getCaseDetailUrl = (caseId: string) => {
  return APP_URLS.CASE_DETAIL.replace(":caseId", caseId);
};

export const getCaseTrackerDetailUrl = (caseId: string) => {
  return APP_URLS.CASE_TRACKER_DETAIL.replace(":caseId", caseId);
};

export const getCaseDebtConsolidationUrl = (
  caseId: string,
  applicationId: string,
) => {
  return APP_URLS.CASE_DEBT_CONSOLIDATION.replace(":caseId", caseId).replace(
    ":applicationId",
    applicationId,
  );
};

export const getCaseDocumentsUrl = (caseId: string) => {
  return APP_URLS.CASE_DOCUMENTS.replace(":caseId", caseId);
};
